'use strict';

var setDateChainableConstructor = require('../internal/setDateChainableConstructor');

setDateChainableConstructor();


// WEBPACK FOOTER //
// ./~/sugar-date/date/build/setDateChainableConstructorCall.js